import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useCallback } from 'react';
import { Platform, View } from 'react-native';

import { MediaItemImage } from '@/features/media/components/MediaItemImage';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { AppRoute } from '@/navigation/types/navigation';
import { FixedSizeCarousel } from '@/shared/components/carousel/FixedSizeCarousel';
import type { CarouselLayoutSize } from '@/shared/types/carousel';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  mediaItems: ClientMediaItem[];
  mediaSize?: MediaItemSize;
  imageHeight?: number;
};

export const ImageCarousel: FC<Props> = ({
  mediaItems,
  mediaSize = MediaItemSize.MEDIUM,
  imageHeight = 260
}) => {
  const { colors } = useAppTheme();

  const navigation = useAppNavigation();
  const handleOpenGallery = useCallback(
    (position: number) =>
      navigation.navigate(AppRoute.Gallery, {
        position,
        mediaUrls: mediaItems.map(({ urls }) => urls.original)
      }),
    [mediaItems, navigation]
  );

  const renderItem = useCallback(
    (item: ClientMediaItem, layout: CarouselLayoutSize, index = 0) => (
      <MediaItemImage
        style={layout}
        mediaItem={item}
        mediaSize={mediaSize}
        onPress={() => handleOpenGallery(index)}
      />
    ),
    [handleOpenGallery, mediaSize]
  );

  return (
    <View
      style={{
        backgroundColor: colors.surfaceContainerLowest,
        // image + pagination
        height: imageHeight + 32
      }}
    >
      <FixedSizeCarousel
        data={mediaItems}
        renderItem={renderItem}
        style={Platform.select({ web: { cursor: 'pointer' } })}
      />
    </View>
  );
};
